import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';

export function MarketCredits() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Market' });
  const { userData } = useAppStore();

  const credits = userData?.credits || 0;

  return (
    <div className="bg-tertiary p-2 flex items-center justify-between">
      <p className="text-sm leading-none">{t('credits')}</p>
      <div className="flex items-center">
        <p className="text-mono text-sm text-gold leading-none">{credits}</p>
        <img src="/assets/items/credit.avif" className="h-4 ml-1" alt="credit" />
      </div>
    </div>
  );
}